<template>
  <el-select
    v-model="defaultEvent"
    class="collapse-tags-select"
    collapse-tags
    filterable
    :multiple="multiple"
    :clearable="clearableType"
    :placeholder="$t(describe)"
    size="small"
    @change="handleEvent"
    @visible-change="initAttr"
    @clear="clearAttr"
    @remove-tag="handleRemove"
  >
    <div v-if="!clearableType || (clearableType && $route.path === '/analyse/attribution')">
      <el-option-group v-for="event in list" :key="event.label" :label="getI18nText(event.label)">
        <el-option
          v-for="(item, index) in event.events"
          :key="index"
          :label="item.label"
          :value="item.value"
          :disabled="disabledList.includes(item.value)"
        >
          <svg-icon v-if="item.value === 'eventOverview'" icon-class="mulu" />
          <span v-if="item.value === 'eventOverview'">{{ item.label }}</span>
        </el-option>
      </el-option-group>
    </div>
    <div v-else>
      <el-option v-for="(item, idx) in list" :key="idx" :label="item.label" :value="item.value" :disabled="disabledList.includes(item.value)">
        <span>{{ item.label }}</span>
      </el-option>
    </div>
    <div>
      <el-checkbox v-if="isSelectAll && list.length > 0" v-model="checked" class="select-all" @change="selectAll">全选</el-checkbox>
    </div>
    <el-option v-if="isSelectAll && list.length > 0" value=""></el-option>

  </el-select>
</template>

<script>
import { clone } from '@U/handle'
export default {
  name: 'SelectFiler',
  props: {
    list: {
      type: Array,
      default: () => []
    },
    describe: {
      type: String,
      default: ''
    },
    attributionType: {
      type: String,
      default: ''
    },
    clearableType: {
      type: Boolean
    },
    multiple: {
      type: Boolean
    },
    bindingEvent: {
      type: [String, Array],
      default: ''
    },
    disabledList: {
      type: Array,
      default: () => []
    },
    isSelectAll: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checked: false,
      defaultEvent: clone(this.bindingEvent),
      multipleInit: false
    }
  },
  watch: {
    bindingEvent(val) {
      this.defaultEvent = val ? clone(val) : null
    }
  },
  methods: {
    selectAll(e) {
      const selected = []
      if (e) {
        this.list.forEach((item) => {
          item.events.forEach((event) => {
            selected.push(event.value)
          })
        })
        this.$emit('initEvenet', selected)
      } else {
        this.$emit('initEvenet', [])
      }
    },
    getI18nText(txt) {
      return (
        {
          虚拟事件: this.$t('route.virtualEvent'),
          点击事件: this.$t('analysis.clickEvent')
        }[txt] || txt
      )
    },
    handleRemove($event) {
      this.$emit('initEvenetRemove', $event)
    },
    handleEvent($event) {
      this.$emit('initEvenet', $event)
    },
    clearAttr($event) {
      this.$emit('clearAttributionEvent', $event)
    },
    initAttr($event) {
      this.$emit('initAttributionEvent', $event)
    }
  }
}
</script>

<style lang="scss" scoped>
/* position: absolute; */
.select-all {
  position: absolute;
  z-index: 99999;
  width: 100%;
  bottom: 0px;
  padding: 4px 0px 0px 20px;
  background-color: #F5F7FA;
  box-shadow: 0px -2px 6px 0px rgba(0, 0, 0, 0.5);
  height: 30px;
}

.collapse-tags-select {
  /deep/ .el-select__tags {
    flex-wrap: nowrap;
    & > span span {
      &:nth-child(1) {
        max-width: inherit;
      }
      &:nth-child(2) {
        @include flex-fixed;
      }
    }
  }
}
</style>
